import { render, staticRenderFns } from "./SignupCompleteSection.vue?vue&type=template&id=2a60ca39&scoped=true"
import script from "./SignupCompleteSection.vue?vue&type=script&lang=ts"
export * from "./SignupCompleteSection.vue?vue&type=script&lang=ts"
import style0 from "./SignupCompleteSection.vue?vue&type=style&index=0&id=2a60ca39&prod&lang=scss&scoped=true"
import style1 from "./SignupCompleteSection.vue?vue&type=style&index=1&id=2a60ca39&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a60ca39",
  null
  
)

export default component.exports